import { Link } from 'react-router-dom';
import bquestLogo from '@/assets/bquest-logo.png';

export const PublicAuthHeader = () => {
  return (
    <header className="sticky top-0 z-50 border-b border-[#025246] bg-[#026857]">
      <div className="container mx-auto px-4 py-3">
        <div className="flex items-center justify-between">
          <div className="flex items-center">
            <Link to="/" className="transition-opacity hover:opacity-80">
              <img src={bquestLogo} alt="bQuest" className="h-8 brightness-0 invert" />
            </Link>
          </div>

          <nav className="flex items-center gap-1">
            <a
              href="https://thebquest.com/about/"
              className="flex items-center gap-2 rounded-md px-3 py-2 text-sm font-termina font-medium uppercase text-white/80 transition-colors hover:bg-white/10 hover:text-white"
              target="_blank"
              rel="noopener noreferrer"
            >
              About Us
            </a>
            <a
              href="https://thebquest.com/pro/"
              className="flex items-center gap-2 rounded-md px-3 py-2 text-sm font-termina font-medium uppercase text-white/80 transition-colors hover:bg-white/10 hover:text-white"
              target="_blank"
              rel="noopener noreferrer"
            >
              Become a BQ Pro
            </a>
            <Link
              to="/login"
              className="flex items-center gap-2 rounded-md bg-white/15 px-3 py-2 text-sm font-termina font-medium uppercase text-white transition-colors"
            >
              Login
            </Link>
          </nav>
        </div>
      </div>
    </header>
  );
};
